/**
 * Every string this UI matches against the advisor backend, in one place.
 *
 * BlockRenderer picks a specialised renderer by node id and by column header, and S4's blocks
 * key their colour markers off line-item labels. That coupling is silent — a copy change on the
 * backend just degrades a rich view to a plain table, with nothing to catch it. Keep in sync
 * with the offer-advisor service.
 */

export const ADVISOR_NODE = {
  /** Market percentiles — a card grid, or a grouped bar chart of the same numbers. */
  MARKET: "S1A_MARKET",
  /** Internal peer distribution — a marker table, or a line chart of the same numbers. */
  INTERNAL: "S1B_INTERNAL",
  /** The final package recommendation. */
  RECOMMEND: "S4_RECOMMEND",
} as const;

/** First-column (and, for S4's comparisons, second-column) headers used to identify a table. */
export const ADVISOR_COLUMN = {
  BONUS_COMPONENT: "Bonus component",
  COMPARED_TO: "Compared to",
  THIS_OFFER_IS: "This offer is",
  PEER_WATERFALL_LAYER: "Layer",
  PEER_WATERFALL_MEDIAN: "Peer median",
} as const;

/** Package-card line items that carry their own colour marker in the composition bar. */
export const ADVISOR_LINE_ITEM = {
  ANNUAL_BASE: "Annual Base",
  CASH_ALLOWANCES: "Cash Allowances",
  TARGET_BONUS: "Target Bonus",
  DISCRETIONARY: "Additional bonus (discretionary)",
} as const;
